<!--Gallery-->
<div class="screenshot-files-content">
  <ng-container *ngIf="app?.screenshotUrls?.length > 0">
    <mat-card appearance="outlined">
      <h2 class="title">Gallery</h2>
      <mat-card-content>
        <section class="app-section-padding">
          <span>
            <section class="screenshot-container">
              <div class="screenshot-item" *ngFor="let img of app?.screenshotUrls; let i = index" (click)="onClick(i)">
                <img class="screenshot-img" [src]="img" [srcset]="getSrcsetImageUrls(img)" />
              </div>
            </section>
          </span>
        </section>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!--Files-->
  <ng-container *ngIf="app && app?.files?.length > 0">
    <mat-card appearance="outlined">
      <h2 class="title">Files & Documents</h2>
      <mat-card-content>
        <section>
          <span>
            <div class="content-container">
              <div *ngFor="let file of app?.files" class="item-container-6">
                <a href="{{ file.url }}" target="_blank">
                  <div class="card-container">
                    <mat-card appearance="outlined" class="mat-card-no-shadow">
                      <mat-card-content class="file-content">
                        <mat-icon class="file-icon file-large-icon" role="img" aria-hidden="true">
                          insert_drive_file
                        </mat-icon>
                        {{ getFileName(file) }}
                      </mat-card-content>
                    </mat-card>
                  </div>
                </a>
              </div>
            </div>
          </span>
        </section>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
